import { graphql } from "api/cms-website/generated";

import { ButtonFragment } from "../primitives/button";

export const MainBannerHeaderFragment = graphql(/* GraphQL */ `
    fragment MainBannerHeaderFragment on ComponentComponentsMainBannerHeader {
        id
        mainBannerHeaderTitle: title
        mainBannerHeaderText: text
        mainBannerHeaderCta: cta {
            ...ButtonFragment
        }
        subtitle
        noMarginBottom
    }
    ${ButtonFragment}
`);
